var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings[0].whatsapp.text)?_c('div',[_c('a',{staticClass:"whatsapp",attrs:{"href":_vm.whatsappLink,"target":"_blank"}},[_c('v-icon',{staticClass:"whatsapp-icon",attrs:{"color":"#fff","large":""}},[_vm._v("mdi-whatsapp")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }